import _isEqual from "lodash/isEqual";
import React from "react";
import { useSelector } from "react-redux";

import DraggableCard from "./DraggableCard";
import { Typography } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import { createStyles, makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme =>
  createStyles({
    rowPlaceholder: {
      display: "none",
      alignItems: "center",
      color: theme.palette.text.hint,
    },
    rowRoot: {
      cursor: "pointer",
      "&:hover": {
        background: theme.palette.grey[100],
      },
      "&:hover $rowPlaceholder": {
        display: "flex",
      },
    },
  }),
);

const Card = ({
  cardId,
  slotNo,
  groupId,
  cardContainerId,
  cardContainerType,
}) => {
  const classes = useStyles();
  const card = useSelector(
    state => state.getIn(["cards", cardId?.toString()]),
    _isEqual,
  );

  if (!card) {
    return (
      <Typography
        align="center"
        variant="caption"
        className={classes.rowPlaceholder}
      >
        <Add />
        <i>Add</i>
      </Typography>
    );
  }

  return (
    <DraggableCard
      card={card} // unused, but will force rerender if card changes
      cardId={cardId}
      slotNo={slotNo}
      groupId={groupId}
      cardType={card.get("type")}
      cardContainerId={cardContainerId}
      cardContainerType={cardContainerType}
    />
  );
};

export default Card;
